import React from 'react';
import Box from '../UI/Box';
import * as SC from './styles';
import Text from '../UI/Text';

const Checkbox: React.FC<ICheckboxProps> = ({
  checked,
  title,
  value,
  size = 14,
  onChange,
}) => {
  return (
    <SC.Label>
      <SC.Check
        type="checkbox"
        value={value}
        checked={checked}
        onChange={onChange}
        title={title}
      />

      <Text
        marginLeft={8}
        fontSize={size}
        lineHeight={`${size}px`}
        textWrap="wrap"
        flex={1}
      >
        {title}
      </Text>
    </SC.Label>
  );
};

export default Checkbox;
